import { styled } from "../../../../../../styles";

export const StyledTooltip = styled("div", {
  borderRadius: "4px",
  padding: "16px 24px 12px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  gap: "4px",

  backgroundColor: "$charcoal",

  maxWidth: "350px",

  h4: {
    color: "$white",

    fontFamily: "$openSans",
    fontSize: "$text-lg",

    lineHeight: "16px",
    marginBottom: "4px",

    fontWeight: 500,
  },

  p: {
    color: "$white",

    fontFamily: "$openSans",
    fontSize: "$text-md",

    lineHeight: "16px",
    marginBottom: "4px",

    fontWeight: 500,
  },
});
